import React from 'react';
import { COLORS, FONTS, META } from '../../globalStyles';
import { styles as doc } from '../../components/documentPage/styles';

// Styles specific to the legal documents. The page column, header, footer and the base
// title/paragraph/link treatment come from documentPage — imported below rather than
// redefined, so there is one definition shared with the 404 page.
export const styles: Record<string, React.CSSProperties> = {

  pageTitle: doc.title,
  paragraph: doc.paragraph,
  link: doc.link,

  // --- States ---

  status: {
    ...META,
    fontSize: '0.72rem',
    color: COLORS.faint,
  },
  // The fetch/parse-failed state. Deliberately NOT a copy of the documents — a stale bundled
  // fallback silently standing in for the live one is its own failure mode. It names the
  // problem and the address to write to, and nothing else.
  fallback: {
    fontFamily: FONTS.body,
    fontSize: '1rem',
    lineHeight: 1.75,
    color: COLORS.muted,
  },
};
